import React, {Component} from "react";
import VideoSystem from 'react-video-js-player';
import {getData, patchData} from "../../api/doLogin";
import {toast} from "react-toastify";
import {getGlobalState} from "../../constants/GlobalStore";
import {formatDateTime} from "../../util/datehelpers";
import {BeforeOnload} from "../../util/beforeOnload";

export class TrainingVideoPlayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      src: null,
      type: null
    }
    this.playData = null;
    this.loginId = getGlobalState("loginID");
    this.instanceID = `${Date.now()}_${this.loginId}`;
    this.timeData = 0;
    this.interval = null;
    this.sent = false;
  }

  start() {
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.timeData++;
      }, 1000);
    }
    BeforeOnload.confirmClose();
  }

  stop() {
    if (!!this.interval) {
      clearInterval(this.interval);
      this.interval = null;
      this.updatePlay();
    }
    BeforeOnload.noConfirmClose();
  }

  reset() {
    this.timeData = 0;
  }

  componentDidMount() {
    BeforeOnload.on("VideoPlayer", () => {
      this.stop();
    })
    this.getFile(this.props.src);
  }

  updatePlay() {
    if (!this.playData) {
      this.playData = {
        id: this.instanceID,
        trainingid: this.props.src,
        userid: this.loginId,
        datetime: formatDateTime(new Date()),
        duration: this.timeData
      }
    } else {
      // if (duration > this.playData.duration) {
      this.playData.duration = this.timeData;
      // }
    }
    this.postUpdate();
  }

  resetPlay() {
    if (!!this.playData) {
      this.playData = null;
      this.instanceID = `${Date.now()}_${this.loginId}`;
      this.timeData = 0;
    }
  }


  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   if (prevProps.src !== this.props.src) {
  //     this.getFile(this.props.src);
  //   }
  // }

  // shouldComponentUpdate(nextProps, nextState, nextContext) {
  //   console.log(nextProps.src, this.props.src, nextState.id, this.state.id)
  //   return !(nextProps.src !== this.props.src && this.state.id === nextState.id);
  // }

  componentWillUnmount() {
    if (this.player) {
      if (!!this.playData) {
        this.postUpdate();
      }
      this.player.dispose()
    }
    BeforeOnload.off("VideoPlayer");
  }

  postUpdate() {
    // console.log(this.playData); //timeData
    const self = this;
    // if (!!sync) {
    //   return patchDataSync(`training/file/${this.props.src || 0}`, {timeData: this.playData});
    // }
    patchData(`training/file/${this.props.src || 0}`, {timeData: this.playData}, this.props.token)
      .then((data) => {

      })
      .catch(error => {
        console.error(error);
        // toast.error("Cannot get file");
      });
  }

  getFile(id) {
    if (!id || id === "") return this.setState({src: null, type: null, id: null});
    const self = this;
    getData(`training/file/${id || 0}`, {}, this.props.token)
      .then((data) => {
        if (data && data.data && data.data.url) {
          self.setState({src: data.data.url, type: data.data.type, id: id});
        }
      })
      .catch(error => {
        console.error(error);
        toast.error("Cannot get file");
      });
  }

  onPlayerReady(player) {
    // player.reset()
    // console.log("Player is ready: ", player);
    this.player = player;
    // console.log(this.state.video.src);
    // player.src([
    //   { type: this.state.video.type, src: this.state.video.src }
    // ]);
    const videoSource = this.state.src && this.state.type ? [{
      src: this.state.src,
      type: this.state.type
    }] : null
    if (videoSource) player.src(videoSource);
  }

  onVideoPlay(duration) {
    // console.log("Video played at: ", duration);
    this.start();
  }

  onVideoPause(duration) {
    // console.log("Video paused at: ", duration);
    this.stop();
  }

  onVideoTimeUpdate(duration) {
    // console.log("Time updated: ", duration);
    // this.timeData++;
    if (this.timeData % 20 === 0 && !this.sent) {
      this.sent = true
      // console.log("Updated", duration);
      this.updatePlay();
      // if (this.timeData > 9999999999) this.timeData = 0;
    }
    if (this.timeData % 20 === 1) {
      this.sent = false
    }
  }

  onVideoSeeking(duration) {
    // console.log("Video seeking: ", duration);
  }

  onVideoSeeked(from, to) {
    // console.log(`Video seeked from ${from} to ${to}`);
  }

  onVideoEnd() {
    // console.log("Video ended");
    this.stop();
    this.resetPlay();
  }

  render() {
    const videoSource = this.state.src && this.state.type ? [{
      src: this.state.src,
      type: this.state.type
    }] : null
    return (
      <div>
        {videoSource && (
          <VideoSystem
            controls={true}
            width="720"
            height="420"
            src={videoSource}
            onReady={this.onPlayerReady.bind(this)}
            onPlay={this.onVideoPlay.bind(this)}
            onPause={this.onVideoPause.bind(this)}
            onTimeUpdate={this.onVideoTimeUpdate.bind(this)}
            onSeeking={this.onVideoSeeking.bind(this)}
            onSeeked={this.onVideoSeeked.bind(this)}
            onEnd={this.onVideoEnd.bind(this)}
          />
        )}

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Shared/VideoPlayer.js